const Backbone = require('backbone');
const Nunjucks = require('view');
const template = require('./index.twig');

const ViewProdutoKit = require('./item');
const ViewDialogCardapio = require('../dialog-cardapio/index');

const View = Backbone.View.extend({
	initialize: function(config) {
		var that = this;
		that.model = new Backbone.Model(config.kit);

		that.$calorias_dia = config.calorias_dia;
		that.$preco_de = config.preco_de;
		that.$preco_por = config.preco_por;
		that.$quantidade = config.quantidade;

		produtos = config.produtos.map(function(record){
			record.estoque = record.estoque|0;
			record.promocao = record.promocao|0;
			record.valor = record.valor * 1.0;
			record.valor_promocional = record.valor_promocional * 1.0;

			return record;
		});

		that.collection = new Backbone.Collection(config.produtos);

		that.listenTo(that.collection,'add',that.addProduto);
		that.listenTo(that.collection, 'update', function() {
			that.setCaloriasDia(),
			that.setPrecoDe(),
			that.setPrecoPor()
		});

		that.listenTo(that.collection, 'change:calorias', function() {
			that.setCaloriasDia();
		});

		that.render();
	},

	setCaloriasDia: function() {
		var that = this;

		var calorias = that.collection.toJSON().reduce(function(cal, porcao){
			return porcao.calorias*1.0 + cal*1.0;
		},0.0);

		calorias = (Math.round(calorias*100)/100).toFixed(2).replace(/\./igm,',');

		that.$calorias_dia.html(calorias);

	},

	setPrecoPor: function() {
		var that = this;

		var preco = that.collection.toJSON().reduce(function(valor, porcao) {
			return valor + porcao.valor;			
		}, 0.0);

		preco = preco.toFixed(2).replace(/\./igm,',');
		that.$preco_de.html(preco);
	},

	setPrecoDe: function() {
		var that = this;

		var preco = that.collection.toJSON().reduce(function(valor, porcao) {
			if (porcao.promocao == 1 && porcao.valor_promocional > 0.0) {
				return valor + porcao.valor_promocional;
			} else {
				return valor + porcao.valor;
			}
		}, 0.0);

		preco = preco.toFixed(2).replace(/\./igm,',');
		that.$preco_por.html(preco);

	},

	addProduto: function(model) {
		var that = this;
		var view = new  ViewProdutoKit({
			model: model
		});

		that.$ul.append(view.$el);
	},
	events: {
		'click .btn-alterar-cardapio': 'showPopupAlterarCardapio',
		'submit [name=formEnviarPorEmail]': 'formEnviarPorEmail'
	},
	formEnviarPorEmail: function(e) {
		var that = this;

		var $form = that.$el.find(e.currentTarget);

		console.log(that.collection.toJSON());

		return false;

	},
	showPopupAlterarCardapio: function(e) {
			var that = this;
			var $self = that.$el.find(e.currentTarget);
			
			
			var view = new ViewDialogCardapio({
				model: that.model,
				collection: that.collection
			});

			$( view.$el).dialog({
				title: 'Alterar Cardápio',
		      	autoOpen: true,
		      	modal: true,
		      	fluid: true,
		      	width: 800,
		      	maxWidth: 800,
		      	show: {
		        	effect: "fadeIn",
		        	duration: 300
		      	},
		      		hide: {
		        	effect: "fadeOut",
		        	duration: 300
		      	},
		      	close: function() {
		      		window.setTimeout(function(){
		      			jQuery(view.el).detach().dialog('destroy').remove();
		      		
		      			view.remove();
		      			delete view;

		      		},0);
		      		$(window).off('resize');
		      	}
		    });
		    $(window).on('resize',function(){
		    	view.$el.dialog({
		    		width: $(window).width() > 800 ? 800 : 'auto'
		    	});
		    	view.$el.dialog('option','position','center');
		    });
	},
	render: function() {
		var that = this;

		var data = that.model.toJSON();

		that.$el.html(Nunjucks.renderString(template,data));
		that.$ul = that.$el.find('ul');

		that.collection.each(function(model){
			that.addProduto(model);
		});
	}
});


module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/kits/interna/index.js
// module id = 36
// module chunks = 0